var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1567",
    "data-name": "Group 1567",
    transform: "translate(-1551 -246)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user",
    transform: "translate(1551 246)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SOLID",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M658.183,949.57a6.129,6.129,0,0,0,6.635,0,.44.44,0,0,1,.237-.07H666.2a4.45,4.45,0,0,1,4.251,4.2l.54,5.56a1.674,1.674,0,0,1-.357,1.215,1.372,1.372,0,0,1-1.06.52h-16.15a1.372,1.372,0,0,1-1.06-.52,1.674,1.674,0,0,1-.357-1.215l.54-5.56a4.45,4.45,0,0,1,4.251-4.2h1.147a.44.44,0,0,1,.237.07ZM661.5,938a5.251,5.251,0,1,1-4.75,5.227A5.008,5.008,0,0,1,661.5,938Z",
    transform: "translate(-652 -938)",
    fill: "#47b0fe",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_110",
    "data-name": "Ellipse 110",
    transform: "translate(1564 259)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 4.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1020",
    "data-name": "Path 1020",
    d: "M0,0V6",
    transform: "translate(1571.621 262.379) rotate(45)",
    fill: "none",
    stroke: "#47b0fe",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1019",
    "data-name": "Path 1019",
    d: "M0,0V6",
    transform: "translate(1567.379 262.379) rotate(-45)",
    fill: "none",
    stroke: "#47b0fe",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLost);
export default __webpack_public_path__ + "static/media/lost.e6bd3a09a040dc5a3e1e1d6e8c16a1e7.svg";
export { ForwardRef as ReactComponent };